import { IconPhone } from "@tabler/icons-react";
import type { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export interface TranscriptCallMarkerProps {
  type: "started" | "ended";
  /** When the call started or ended, already formatted; omitted for a simulated call. */
  formattedTime?: string;
  /** A trailing control, such as a play button for the call. */
  action?: ReactNode;
}

export const TranscriptCallMarker: FC<TranscriptCallMarkerProps> = (props) => {
  const { type, formattedTime, action } = props;

  return (
    <div className="flex items-center justify-center space-x-2 py-2 text-sm">
      <IconPhone
        className={twMerge(
          "size-4",
          type === "started" ? "text-green-500" : "text-red-500",
        )}
      />
      <span>{type === "started" ? "Call started" : "Call ended"}</span>
      {formattedTime ? (
        <span className="text-muted-foreground">{formattedTime}</span>
      ) : null}
      {action}
    </div>
  );
};
